import { render, staticRenderFns } from "./StorageItem.vue?vue&type=template&id=16da2f22&scoped=true&"
import script from "./StorageItem.vue?vue&type=script&lang=js&"
export * from "./StorageItem.vue?vue&type=script&lang=js&"
import style0 from "./StorageItem.vue?vue&type=style&index=0&id=16da2f22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16da2f22",
  null
  
)

export default component.exports